import { render, staticRenderFns } from "./RmrSoftBadge.vue?vue&type=template&id=658dc872&scoped=true&"
import script from "./RmrSoftBadge.vue?vue&type=script&lang=js&"
export * from "./RmrSoftBadge.vue?vue&type=script&lang=js&"
import style0 from "./RmrSoftBadge.vue?vue&type=style&index=0&id=658dc872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658dc872",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
